import { Link } from "react-router-dom";
import type { SystemStatus } from "../types";

/**
 * Честно говорим, чего не хватает для полного цикла. Приложение работает
 * и без ключей — просто часть шагов встаёт в очередь и ждёт.
 * Обычным сотрудникам эта техническая подсказка не нужна.
 *
 * Про Zoom здесь молчим: основная работа — очные встречи, и без ключей Zoom
 * она идёт целиком. Состояние ключей всё равно видно в разделе «Состояние».
 */
export function SetupBanner({
  status,
  isAdmin,
}: {
  status: SystemStatus | null;
  isAdmin: boolean;
}) {
  if (!status || !isAdmin) return null;

  const gaps: string[] = [];
  if (!status.ai.configured) gaps.push("ANTHROPIC_API_KEY");
  if (!status.telegram.configured) gaps.push("TELEGRAM_BOT_TOKEN");

  if (gaps.length === 0) return null;

  return (
    <div className="banner amber">
      <span>⚠️</span>
      <div>
        <strong>Не хватает настроек: {gaps.join(", ")}</strong>
        Без этих ключей записи со встреч не расшифруются и карточки клиентов
        не соберутся. Всё, что их требует, копится в очереди задач и выполнится
        само, как только они появятся в <span className="mono">.env</span>.{" "}
        <Link to="/system">Открыть состояние</Link>
      </div>
    </div>
  );
}
